import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titlePipe',
  pure: true,
})
export class TitlePipe implements PipeTransform {
  transform(item: number): any {
    // TODO: find a better solution
    // problem is that the tenantConfig titles are
    // not real enums so the reverse diretion
    // number to value doesnt work
    let title = '';
    switch (item) {
      case 1:
        title = 'Dr.';
        break;
      case 2:
        title = 'Prof. Dr.';
        break;
      case 3:
        title = 'Dipl. Ing.';
        break;
      case 4:
        title = 'Dipl. med.';
        break;
      case 5:
        title = 'Dipl. Psych.';
        break;
      case 6:
        title = 'Dr. Dr.';
        break;
      case 7:
        title = 'Dr. med.';
        break;
      case 9:
        title = 'Prof.';
        break;
      case 10:
        title = 'Prof. Dr. med.';
        break;
    }
    return title;
  }
}
